import React from "react";

import { contactSupport } from "~/lib/utils";

export default function ContactSupportLink({
	children,
	message,
	onClick,
}: {
	children: string;
	message?: string;
	onClick?: () => void;
}) {
	const onContactSupport = React.useCallback(
		(e: React.MouseEvent) => {
			if (window.Intercom) {
				if (!e.altKey && !e.ctrlKey && !e.metaKey && !e.shiftKey) {
					e.preventDefault();
					contactSupport(message);
				}
			}
			onClick?.();
		},
		[message, onClick],
	);

	const mailUrl = `mailto:help@fellow.app?body=${message ? encodeURIComponent(message) : ""}`;

	return (
		<a href={mailUrl} target="_blank" rel="noopener noreferrer" onClick={onContactSupport}>
			{children}
		</a>
	);
}
